<template>
	<div class="main">
		<div class="up">{{comp.introEn}}</div>
		<div class="down">{{comp.contactEn}}</div>
	</div>
</template>

<script>
export default {
	name: "Equip",
	data() {
		return{
			comp: {}
		}
	},
	mounted() {
		this.$api.get('about/getEquip').then(res => {
			this.comp = res;
		});
	}
}
</script>

<style scoped>
.main{ font-family: 'SiYuan-ExtraLight', sans-serif; }
@media (max-width: 999px){
	.main{ margin-top: 19px; }
	.up{ animation: fadeInRight; animation-duration: 1s; line-height: 36px; white-space: pre-wrap; }
	.down{ font-size: 13px; animation: fadeInUp; animation-duration: 1.3s; white-space: pre-wrap; margin-top: 18px; }
}
@media (min-width: 999px){
	.main{ margin-top: 30px; }
	.up{ animation: fadeInRight; animation-duration: 1s; line-height: 36px; white-space: pre-wrap; }
	.down{ font-size: 14px; animation: fadeInUp; animation-duration: 1.3s; white-space: pre-wrap; margin-top: 18px; }
}
</style>